import type { ReactNode } from "react";

import { ContactCountBadge } from "./ContactCountBadge";

export const ContactTabLabel = ({
  label,
  count,
}: {
  label: ReactNode;
  count?: number;
}) => (
  <span className="inline-flex items-center gap-1.5">
    {label}
    {count != null && <ContactCountBadge count={count} />}
  </span>
);
